import { useLiveQuery } from 'dexie-react-hooks';
import { replica } from './replica';

/** Local changes not yet confirmed by the server. */
export function usePendingCount(): number | undefined {
  return useLiveQuery(() => replica.db.outbox.count());
}
